// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"b9edcabb","453":"30288c7d"}[chunkId] + ".chunk.js";
};